import { render, staticRenderFns } from "./shipConfirm.vue?vue&type=template&id=94ef08e0"
import script from "./shipConfirm.vue?vue&type=script&lang=js"
export * from "./shipConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports